export class ParticipantService {
    constructor (data) {
        // this.campaignId = 0
        this.userId = data ? data.userId : ""
        this.name = data ? data.name : ""
        this.patronymic = data ? data.patronymic : ""
        this.phone = data ? data.phone : ""
        this.surname = data ? data.surname : ""
        this.amount = 0
        this.availability = false
       this.obj = {}
    }

    add_data (data) {
        // this.campaignId = 0
        this.userId = data ? (data.id ? data.id : data.userProfileId) : ""
        this.name = data ? (data.name ? data.name : "") : ""
        this.patronymic = data ? (data.patronymic ? data.patronymic : "") : ""
        this.phone = data ? data.phone : ""
        this.surname = data ? (data.surname ? data.surname : "") : ""
        this.amount = 0
        this.availability = false
        this.obj = Object.assign({}, {
            // campaignId: this.campaignId,
            userId: this.userId,
            name: this.name,
            patronymic: this.patronymic,
            phone: this.phone,
            surname: this.surname,
            amount: this.amount,
            availability: this.availability
        })
        return this
    }

    get fullName () {
        return `${this.name !== undefined ? this.name : ''} ${this.patronymic !== undefined ? this.patronymic : ''} ${this.surname !== undefined ? this.surname : ''}`
    }

    get item () {
        Object.assign(this.obj, { fullName: this.fullName })
        return this.obj
    }
}
